import { Routes } from '@angular/router';
import { HasBasketGuard } from '@data-access';

export const appRoutes: Routes = [
  {
    path: 'appliance-details',
    loadComponent: () =>
      import('@features/appliance-details-stepped').then(
        (module) => module.HomepageComponent,
      ),
  },
  {
    path: 'protection-details',
    loadComponent: () =>
      import('@features/single-plan').then(
        (module) => module.SinglePlanSaleComponent,
      ),
    canActivate: [HasBasketGuard],
  },
  {
    path: 'multi-plan',
    canActivate: [HasBasketGuard],
    children: [
      {
        path: '',
        redirectTo: 'protection-details',
        pathMatch: 'full',
      },
      {
        path: 'protection-details',
        loadComponent: () =>
          import('@features/multi-plan').then(
            (module) => module.PlanSaleComponent,
          ),
      },
      {
        path: 'appliance-details',
        loadComponent: () =>
          import('@features/multi-plan').then(
            (module) => module.ApplianceDetailsComponent,
          ),
      },
      {
        path: 'review-cover',
        loadComponent: () =>
          import('@features/multi-plan').then(
            (module) => module.ReviewCoverComponent,
          ),
      },
    ],
  },
  {
    path: 'contact-details',
    loadComponent: () =>
      import('@features/checkout').then(
        (module) => module.ContactDetailsComponent,
      ),
  },
  {
    path: 'direct-debit',
    loadComponent: () =>
      import('@features/checkout').then((module) => module.CheckoutComponent),
  },
  {
    path: 'registration-confirmation',
    loadComponent: () =>
      import('@features/registration-confirmation').then(
        (module) => module.RegistrationConfirmationComponent,
      ),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('@features/error').then((module) => module.ErrorComponent),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('@features/support').then(
        (module) => module.SupportNavigationComponent,
      ),
    children: [
      {
        path: 'accessibility-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.AccessibilityPolicyComponent,
          ),
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.ContactUsComponent,
          ),
      },
      {
        path: 'cookies-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.CookiesPolicyComponent,
          ),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.PrivacyPolicyComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'appliance-details',
    pathMatch: 'full',
  },
];
